// AUTOGENERATED — do not edit. Source: schemas/modes/elysiamorf.json. Run `bun run codegen/generate.ts` to regenerate.
import type { ModeSchema } from './types';

export interface ElysiamorfParams {
  readonly fm0_carrier: number;
  readonly fm0_mod_freq: number;
  readonly fm0_mod_index: number;
  readonly fm0_phasor_mul: number;
  readonly fm0_phase_off: number;
  readonly fm1_carrier: number;
  readonly fm1_mod_freq: number;
  readonly fm1_mod_index: number;
  readonly fm1_phasor_mul: number;
  readonly fm1_phase_off: number;
  readonly fm2_carrier: number;
  readonly fm2_mod_freq: number;
  readonly fm2_mod_index: number;
  readonly fm2_phasor_mul: number;
  readonly fm2_phase_off: number;
  readonly fm3_carrier: number;
  readonly fm3_mod_freq: number;
  readonly fm3_mod_index: number;
  readonly fm3_phasor_mul: number;
  readonly fm3_phase_off: number;
  readonly fm4_carrier: number;
  readonly fm4_mod_freq: number;
  readonly fm4_mod_index: number;
  readonly fm4_phasor_mul: number;
  readonly fm4_phase_off: number;
  readonly fm5_carrier: number;
  readonly fm5_mod_freq: number;
  readonly fm5_mod_index: number;
  readonly fm5_phasor_mul: number;
  readonly fm5_phase_off: number;
  readonly fm6_carrier: number;
  readonly fm6_mod_freq: number;
  readonly fm6_mod_index: number;
  readonly fm6_phasor_mul: number;
  readonly fm6_phase_off: number;
  readonly fm7_carrier: number;
  readonly fm7_mod_freq: number;
  readonly fm7_mod_index: number;
  readonly fm7_phasor_mul: number;
  readonly fm7_phase_off: number;
}

export const ElysiamorfSchema: ModeSchema = {
  mode_id: 'elysiamorf',
  engine_id: 'elysiamorf',
  ml: {
    input_channels: [
      'joy_x',
      'joy_y',
      'joy_z',
      'joy_w',
    ],
    input_size: 4,
    hidden_layers: [
      10,
      14,
      18,
    ],
    output_size: 40,
    default_spread: 0.6,
  },
  params: [
    {
      name: 'fm0_carrier',
      label: 'FM0 Carrier',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm0',
    },
    {
      name: 'fm0_mod_freq',
      label: 'FM0 Mod Freq',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm0',
    },
    {
      name: 'fm0_mod_index',
      label: 'FM0 Mod Index',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm0',
    },
    {
      name: 'fm0_phasor_mul',
      label: 'FM0 Phasor Mul',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm0',
    },
    {
      name: 'fm0_phase_off',
      label: 'FM0 Phase Off',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm0',
    },
    {
      name: 'fm1_carrier',
      label: 'FM1 Carrier',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm1',
    },
    {
      name: 'fm1_mod_freq',
      label: 'FM1 Mod Freq',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm1',
    },
    {
      name: 'fm1_mod_index',
      label: 'FM1 Mod Index',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm1',
    },
    {
      name: 'fm1_phasor_mul',
      label: 'FM1 Phasor Mul',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm1',
    },
    {
      name: 'fm1_phase_off',
      label: 'FM1 Phase Off',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm1',
    },
    {
      name: 'fm2_carrier',
      label: 'FM2 Carrier',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm2',
    },
    {
      name: 'fm2_mod_freq',
      label: 'FM2 Mod Freq',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm2',
    },
    {
      name: 'fm2_mod_index',
      label: 'FM2 Mod Index',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm2',
    },
    {
      name: 'fm2_phasor_mul',
      label: 'FM2 Phasor Mul',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm2',
    },
    {
      name: 'fm2_phase_off',
      label: 'FM2 Phase Off',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm2',
    },
    {
      name: 'fm3_carrier',
      label: 'FM3 Carrier',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm3',
    },
    {
      name: 'fm3_mod_freq',
      label: 'FM3 Mod Freq',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm3',
    },
    {
      name: 'fm3_mod_index',
      label: 'FM3 Mod Index',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm3',
    },
    {
      name: 'fm3_phasor_mul',
      label: 'FM3 Phasor Mul',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm3',
    },
    {
      name: 'fm3_phase_off',
      label: 'FM3 Phase Off',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm3',
    },
    {
      name: 'fm4_carrier',
      label: 'FM4 Carrier',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm4',
    },
    {
      name: 'fm4_mod_freq',
      label: 'FM4 Mod Freq',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm4',
    },
    {
      name: 'fm4_mod_index',
      label: 'FM4 Mod Index',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm4',
    },
    {
      name: 'fm4_phasor_mul',
      label: 'FM4 Phasor Mul',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm4',
    },
    {
      name: 'fm4_phase_off',
      label: 'FM4 Phase Off',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm4',
    },
    {
      name: 'fm5_carrier',
      label: 'FM5 Carrier',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm5',
    },
    {
      name: 'fm5_mod_freq',
      label: 'FM5 Mod Freq',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm5',
    },
    {
      name: 'fm5_mod_index',
      label: 'FM5 Mod Index',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm5',
    },
    {
      name: 'fm5_phasor_mul',
      label: 'FM5 Phasor Mul',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm5',
    },
    {
      name: 'fm5_phase_off',
      label: 'FM5 Phase Off',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm5',
    },
    {
      name: 'fm6_carrier',
      label: 'FM6 Carrier',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm6',
    },
    {
      name: 'fm6_mod_freq',
      label: 'FM6 Mod Freq',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm6',
    },
    {
      name: 'fm6_mod_index',
      label: 'FM6 Mod Index',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm6',
    },
    {
      name: 'fm6_phasor_mul',
      label: 'FM6 Phasor Mul',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm6',
    },
    {
      name: 'fm6_phase_off',
      label: 'FM6 Phase Off',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm6',
    },
    {
      name: 'fm7_carrier',
      label: 'FM7 Carrier',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm7',
    },
    {
      name: 'fm7_mod_freq',
      label: 'FM7 Mod Freq',
      min: 0,
      max: 1,
      default: 0.5,
      curve: 'linear',
      group: 'fm7',
    },
    {
      name: 'fm7_mod_index',
      label: 'FM7 Mod Index',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm7',
    },
    {
      name: 'fm7_phasor_mul',
      label: 'FM7 Phasor Mul',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm7',
    },
    {
      name: 'fm7_phase_off',
      label: 'FM7 Phase Off',
      min: 0,
      max: 1,
      default: 0,
      curve: 'linear',
      group: 'fm7',
    },
  ],
  voice_spaces: [],
  curve_overrides: [],
  ui: {
    primary_input: 'xy_pad',
    show_voice_space_selector: false,
    show_synth_visualizer: false,
  },
};
